export default "__VITE_ASSET__BS4ucF6N__"